// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accordion":"accordion_4SQ75"};